import typography from './typography';

export default {
  borderRadius: '24px',
  fontSize: '1rem',
  fontWeight: typography.baseFontWeight,
  height: '3rem',
  padding: '3rem',
};
